<template>
    <div class="contenedor-tablas"><br>
      <!-- Tabla Precio CO₂ -->
      <div class="tabla-contenedor" >
        <table >
          <thead >
            <tr>
              <th style="border-top-left-radius: 10px !important; border-top-right-radius: 10px !important;" class="encabezado" colspan="3">{{ labels.precios }}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td class="columna-ancha primera_columna">{{ labels.precioCO2 }}</td>
              <td class="input">
                <input 
                  type="number" 
                  v-model="precioCO2Local" 
                  @input="emitirCambio('precioCO2', precioCO2Local)"
                />
              </td>
              <td class="columna-ancha">{{ labels.eurTonelada }}</td>
            </tr>
          </tbody>
        </table>
      </div>
  
      <!-- Tabla Electricidad Cerrada -->
      <div class="tabla-contenedor" >
        <table>
          <tbody>
            <tr>
              <td class="columna-ancha primera_columna" style="white-space: wrap !important;">{{ labels.precioElectricidadCerrado }}</td>
              <td class="input">
                <input 
                  type="number" 
                  v-model="precioElectricidadCerradoLocal" 
                  @input="emitirCambio('precioElectricidadCerrado', precioElectricidadCerradoLocal)"
                />
              </td>
              <td class="columna-ancha ">{{ labels.eurMWh }}</td>
            </tr>
            <!-- <tr>
              <td class="columna-ancha">{{ labels.potenciaElectricidadCerrado }}</td>
              <td class="input">
                <input 
                  step="0.1"
                  type="number" 
                  v-model="potenciaElectricidadCerradoLocal" 
                  @input="emitirCambio('potenciaElectricidadCerrado', potenciaElectricidadCerradoLocal)"
                />
              </td>
              <td class="columna-ancha">{{ labels.mwh }}</td>
            </tr> -->
          </tbody>
        </table>
      </div>
  
      <!-- Tabla Impuesto Generación -->
      <div class="tabla-contenedor" >
        <table>
          <thead>
            <tr>
              <th class="encabezado" style="border-top-left-radius: 10px !important; border-top-right-radius: 10px !important;" colspan="3">{{ labels.otros }}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td class="primera_columna">{{ labels.impuestoGeneracion }}</td>
              <td class="input">
                <input 
                  type="number" 
                  v-model="impuestoGeneracionLocal" 
                  step="0.01"
                  @input="emitirCambio('impuestoGeneracion', impuestoGeneracionLocal / 100)"
                />
              </td>
              <td>%</td>
            </tr>
          </tbody>
        </table>
      </div>
      <!-- Tabla Banda Secundaria -->
      <div class="tabla-contenedor" >
        <table>
          <thead>
            <tr>
              <th class="encabezado" style="border-top-left-radius: 10px !important; border-top-right-radius: 10px !important;" colspan="3">{{ labels.bandaSecundaria }}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td class="primera_columna">{{ labels.minTecnico }}</td>
              <td class="input">
                <input 
                type="number" 
                v-model="minTecnicoLocal" 
                @input="emitirCambio('minTecnico', minTecnicoLocal)"
              />
              </td>
              <td>MW</td>
            </tr>
            <tr>
              <td class="primera_columna">{{ labels.cantidadMin }}</td>
              <td class="input">
                <input 
                type="number" 
                v-model="cantidadMinLocal" 
                @input="emitirCambio('cantidadMin', cantidadMinLocal)"
              />
              </td>
              <td>MW</td>
            </tr>
            <tr>
              <td class="primera_columna">{{ labels.cantidadMax }}</td>
              <td class="input">
                <input 
                type="number" 
                v-model="cantidadMaxLocal" 
                @input="emitirCambio('cantidadMax', cantidadMaxLocal)"
              />
              </td>
              <td>MW</td>
            </tr>
            <tr>
              <td class="primera_columna">{{ labels.oferta }}</td>
              <td class="input">
                <input 
                  type="number" 
                  v-model="ofertaLocal" 
                  @input="emitirCambio('oferta', ofertaLocal)"
                />
              </td>
              <td>€/MWh</td>
            </tr>
          </tbody>
        </table>
      </div>

    </div>
  </template>
  
  <script>

  export default {
    props: {
      precioCO2: Number,
      precioElectricidadCerrado: Number,
      potenciaElectricidadCerrado: Number,
      impuestoGeneracion: Number,
      minTecnico: {
        type: Number,
        default: 28
      },
      cantidadMin: {
        type: Number,
        default: 16
      },
      cantidadMax: {
        type: Number,
        default: 47.4
      },
      oferta: {
        type: Number,
        default: 95
      }
    },
    data() {
      return {
        precioCO2Local: this.precioCO2,
        precioElectricidadCerradoLocal: this.precioElectricidadCerrado,
        potenciaElectricidadCerradoLocal: this.potenciaElectricidadCerrado,
        impuestoGeneracionLocal: Math.round(this.impuestoGeneracion * 10000)/100,
        minTecnicoLocal: this.minTecnico,
        cantidadMinLocal: this.cantidadMin,
        cantidadMaxLocal: this.cantidadMax,
        ofertaLocal: this.oferta,
  
        labels: {
          precios: this.$t("otros.precios"),
          precioCO2: this.$t("otros.precio_CO2"),
          eurTonelada: this.$t("otros.eur_tonelada"),
          precioElectricidadCerrado: this.$t("otros.precio_electricidad_cerrado"),
          potenciaElectricidadCerrado: this.$t("otros.potencia_precio_electricidad_cerrado"),
          eurMWh: this.$t("otros.eur_mwh"),
          mwh: this.$t("otros.mwh"),
          otros: this.$t("otros.otros"),
          impuestoGeneracion: this.$t("otros.impuesto_generacion"),
          bandaSecundaria: this.$t("otros.banda_sec"),
          minTecnico:this.$t("otros.min_tec"),
          cantidadMin:this.$t("otros.cantidad_min"),
          cantidadMax:this.$t("otros.cantidad_max"),
          oferta:this.$t("otros.oferta"),
        }
      };
    },
    methods: {
      emitirCambio(nombre, valor) {
        this.$emit(`update:${nombre}`, valor);
      }
    }
  };
  </script>
  
  <style scoped>
  .contenedor-tablas {
    width: 80%;
   
    justify-content: left;
  }
  
  .table-header {
    font-size: 1.3em;
    font-weight: bold;
    text-align: center;
    margin-bottom: 15px;
    color: white;
    background-color: #006699;
    padding: 8px;
    border-radius: 10px;
  }
  
  .tabla-contenedor {
    margin-bottom: 40px; /* Aumenta la separación entre tablas */
    display: flex;
    justify-content: left;
    border-radius: 10px;
    overflow-x: auto;
  }
  
  table {
    width: 70%;
    border-collapse: collapse;
    text-align: center;
    table-layout: fixed;
    
  }
  


  td {
    font-weight: bold;
    color: #686868;
     border-top: 2px solid #D9D9D9; 
    border-bottom: 2px solid #D9D9D9;
    padding: 5px;
    background-color: white;
    text-align:center;
  }
  
  /* input {
    width: 100%;
    text-align: center;
    border: none;
    background: #F2F2F2;
    font-size: 14px;
    font-weight: bold;
    color: #024e74;
    padding: 8px;
  } */
     input[type="number"] {
    width: 100%;
    text-align: center;
    border: none;
    border-radius: 4px;
    color: #686868;
    text-align: right;
   
  }
  
 /*  input:focus {
    outline: none;
    border-bottom: 2px solid #024e74;
  } */
  /* Establecer el mismo tamaño para todas las columnas */
/* .columna-ancha {
  width: 33%;
} */
  </style>
  